export default __webpack_public_path__ + "static/media/top_w576up992down_1.bdb80efa.png";